import { app } from '../../../bootstrap/core';
import { infoBoxComponent } from './infoBox.component';

app.component('infoBox', infoBoxComponent);
